module.exports = "/_next/static/images/CompassMorowali-e1cd10bf7cf192d4a0f6d5000922ab44.svg";